<template>
<Intro />
  <section id="hero" class="hero">
        <div class="container">
            <h1>Your Best Hair Day Starts Here</h1>
            <p>Expert cuts, vibrant color, and personalized styling in a luxurious environment.</p>
            
        </div>
        <SalonImgSlider class="full-width-class"/>
        <a href="#booking" class="cta-button">Book Now</a>
    </section>

    <section id="services" class="services">
        <div class="container">
            <h2>Our Premium Services</h2>
            <div class="services-grid">
                <div class="service-card">
                    <h3>Hair Cuts & Styling</h3>
                    <p>From classic trims to trendy transformations, tailored just for you.</p>
                </div>
                <div class="service-card">
                    <h3>Vibrant Color</h3>
                    <p>Highlights, balayage, and full-color treatments with premium products.</p>
                </div>
                <div class="service-card">
                    <h3>Treatments</h3>
                    <p>Deep conditioning, keratin, and scalp treatments for healthy, strong hair.</p>
                </div>
            </div>
        </div>
    </section>

    <section id="gallery" class="gallery">
        <div class="container">
            <h2>Recent Work & Style Inspiration</h2>
            
        </div>
        <SalonWorkSlides class="full-width-class"/>
        <a href="#booking" class="cta-button">Book Now</a>
    </section>

    <section id="team" class="team">
        <div class="container">
            <h2>Meet Our Master Stylists</h2>
            
        </div>
        <TeamSlides class="full-width-class"/>
    </section>

    <TextInRed />
    

</template>

<script>
import Intro from '../components/landing_page_sliders/Intro.vue'
import SalonImgSlider from './landing_page_sliders/SalonImgSlider.vue'
import SalonWorkSlides from './landing_page_sliders/SalonWorkSlides.vue'
import TeamSlides from './landing_page_sliders/TeamSlides.vue'
import TextInRed from './landing_page_sliders/TextInRed.vue'
export default {
    name: 'LandingPage',
    components: {
        Intro,
        SalonImgSlider,
        SalonWorkSlides,
        TeamSlides,
        TextInRed,
    }
}
</script>

<style scoped>

        :root {
            --color-maroon: #5D0E1F;    /* Deep Berry/Maroon (Primary Accent) */
            --color-gold: #FBBF24;      /* Amber/Gold (Secondary Accent) */
            --color-earth: #A0522D;     /* Sienna/Earth Tone (Action/Detail) */
            --color-dark: #1c1917;      /* Nearly Black (Text/Header BG) */
            --color-light: #f5f5f4;     /* Off-White/Stone (Background) */
            --color-gray: #666;         /* For secondary text */

            --font-serif: 'Playfair Display', serif; 
            --font-sans: 'Inter', sans-serif;       
        }

        /* Base Styles */
        .container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 0 1.5rem; /* Increased padding */
            font-family: var(--font-sans);
        }

        /* Ensure that the sliders span the width of the screen*/
        .full-width-class {
            width: 100vw;
            margin-left: calc(50% - 50vw); 
            overflow: hidden; /* Prevent horizontal scrollbar on the page */
            margin-top: 3rem; /* Add vertical spacing above the slider */
            margin-bottom: 3rem; /* Add vertical spacing below the slider */
            height: 600px;
            
        }

        section {
            padding: 5rem 0; /* More vertical spacing */
            text-align: center;
        }

        section .hero .gallery .team {
            background-position: center;
            background-size: cover;
            
          
            background-attachment: fixed;
        }

        h1 {
            font-family: var(--font-serif); /* Elegant serif for main heading */
            font-size: 3.5rem; /* Larger heading */
            font-weight: 700; /* Slightly lighter for elegance */
            margin-bottom: 1.5rem;
            color: #5D0E1F; /* Maroon for impact */
            line-height: 1.2;
        }

        h2 {
            font-family: var(--font-serif); /* Elegant serif for section headings */
            text-align: center;
            font-size: 2.8rem; /* Larger headings */
            font-weight: 600;
            color: #1c1917;
            margin-bottom: 3rem; /* More space below headings */
            position: relative;
            padding-bottom: 0.5rem;
        }

        h2::after { /* Decorative underline for h2 */
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 80px; /* Short gold underline */
            height: 3px;
            background-color: #FBBF24;
            border-radius: 2px;
        }

        /* Hero Section */
        .hero {
            background-color: #f5f5f4; /* Light background for hero */
            color: #1c1917;
        }

        .hero p {
            font-family: var(--font-sans);
            font-size: 1.25rem; /* Larger paragraph text */
            margin-bottom: 2.5rem;
            color: #4a4a4a; /* Softer dark for body text */
            max-width: 800px;
            margin-left: auto;
            margin-right: auto;
        }

        .cta-button {
            display: inline-block;
            background-color: #5D0E1F; /* Maroon CTA */
            color: white;
            padding: 1rem 2.5rem; /* Larger padding */
            margin-top: 3rem; /* More space above button */
            border-radius: 30px; /* More rounded pill shape */
            font-weight: 700;
            font-size: 1.1rem;
            text-decoration: none;
            transition: background-color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease;
            box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2); /* Subtle shadow */
        }

        .cta-button:hover {
            background-color: #4a0c19; /* Darker Maroon on hover */
            transform: translateY(-2px) scale(1.02); /* Lift and slightly enlarge */
            box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
        }
        
        /* Services Section */
        .services {
            background-color: white; /* White background for services */
            color: #1c1917;
        }

        .services h2 {
            color: #A0522D; 
        }
        .services-grid { 
            display: grid;
            grid-template-columns: 1fr; /* Single column on mobile */
            gap: 2.5rem; /* Increased gap */
            margin-top: 3rem;
        }

        .service-card {
            background-color: #fffaf0; /* Light gold background for service cards */
            padding: 2.5rem; /* More padding 
            border-radius: 1.5rem;*/
            box-shadow: 0 10px 20px rgba(0, 0, 0, 0.08); /* Softer shadow */
            border-top: 5px solid #FBBF24; /* Prominent gold top border */
            transition: transform 0.4s ease, box-shadow 0.4s ease;
        }

        .service-card:hover {
            transform: translateY(-5px); /* Lift significantly on hover */
            box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15); /* Stronger shadow on hover */
        }

        .service-card h3 {
            font-family: var(--font-serif);
            font-size: 1.8rem; /* Larger service card title */
            font-weight: 600;
            color: #5D0E1F; /* Maroon for service titles */
            margin-bottom: 0.75rem;
        }
        .service-card p {
            font-size: 1rem;
            color: #555;
            line-height: 1.6;
        }
        
        /* Gallery Section */
        .gallery {
            background-color: #1c1917; /* Dark background for gallery */
        }
        .gallery h2 {
            color: #FBBF24; /* Gold heading for gallery */
        }

        /* Team Section */
        .team {
            background-color: #f5f5f4; /* Light background for team */
        }
        .team h2 {
            color: #A0522D; /* Earth tone heading for team */
        }

        /* Responsive adjustments */
        @media (min-width: 768px) {
            h1 {
                font-size: 4.5rem; /* Larger on desktop */
            }
            h2 {
                font-size: 3.2rem;
            }
            .services-grid { 
                grid-template-columns: repeat(2, 1fr); 
            }
        }
        @media (min-width: 1024px) {
            .services-grid { 
                grid-template-columns: repeat(3, 1fr); /* 3 columns on larger desktops */
            }
        }
        </style>
